import Loading from "./loading.vue";

export default class {
  constructor(Vue) {
    this.instance = null;
    this.LoadingC = Vue.extend(Loading);
    this.vue = Vue
  }
  initInstance () {
    // 创建子类实例
    this.instance = new this.LoadingC({
      el: document.createElement('div')
    });
    // 插到body里
    document.body.appendChild(this.instance.$el);
    this.vue.nextTick(() => {
      this.instance.loading = true;
    });
  }
  show () {
    if (!this.instance) {
      this.initInstance();
    }
    this.instance.loading = true;
  }
  hide () {
    if (this.instance) {
      this.instance.loading = false;
    }
  }
}




// WEBPACK FOOTER //
// ./src/plugins/loading/index.js